export default __webpack_public_path__ + "assets/5a5dff.svg";